import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BlockedByAdmin from '../userBlocked';

export class BlockedModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func,
    options: PropTypes.object,
  };
  render() {
    const { hideModal, options } = this.props;
    return <BlockedByAdmin onClose={hideModal} options={options} />;
  }
}
